import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SiteAuditView from '@/components/SiteAuditView';

const base = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function PublicSiteAudit() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    document.title = "Site Audit | Fieldlink NZ";
    let alive = true, expiryTimer;
    const controller = new AbortController();
    async function refresh() {
      try {
        const response = await fetch(`${base}/public/site-audit/${encodeURIComponent(token)}`, { cache: 'no-store', credentials: 'omit', referrerPolicy: 'no-referrer', signal: controller.signal });
        const result = await response.json();
        if (!response.ok) throw new Error(result.detail || 'This Site Audit Pass is no longer available.');
        if (alive) {
          setData(result); setError('');
          clearTimeout(expiryTimer);
          expiryTimer = setTimeout(() => { setData(null); setError('This Site Audit Pass has expired. Ask a site representative to generate a new pass.'); }, Math.max(0, Date.parse(result.pass.expires_at) - Date.now()));
        }
      } catch (e) {
        if (alive && e.name !== 'AbortError') { setData(null); setError(e.message === 'Failed to fetch' ? 'Unable to verify this pass. Reconnect to view current records.' : e.message); }
      }
    }
    refresh();
    const timer = setInterval(refresh, 15000);
    const onVisible = () => { if (!document.hidden) refresh(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { alive = false; controller.abort(); clearInterval(timer); clearTimeout(expiryTimer); document.removeEventListener('visibilitychange', onVisible); };
  }, [token]);
  async function openDocument(path) {
    const response = await fetch(`${base}/public/site-audit/${encodeURIComponent(token)}/documents/${path}`, { credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer' });
    if (!response.ok) {
      setData(null); setError('This document or Site Audit Pass is no longer available.');
      throw new Error('Document unavailable');
    }
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a'); anchor.href = url; anchor.download = blob.type === 'application/pdf' ? 'site-audit-document.pdf' : 'site-audit-document'; anchor.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
  return <main className="min-h-screen bg-[#f3f5f6] px-4 py-6"><div className="max-w-2xl mx-auto">
    <div className="text-xl font-black tracking-tight text-[#102130] mb-5">FIELDLINK<span className="text-[#FF5F15]"> NZ</span></div>
    {error ? <div className="rounded-xl border bg-white p-6" role="alert"><h1 className="font-semibold mb-3">Site Audit</h1><p>{error}</p></div> : data ? <SiteAuditView data={data} openDocument={openDocument}/> : <p role="status">Loading Site Audit…</p>}
  </div></main>;
}
